import {
    SHOW_INLINE_IMAGE_LOADER,
    REMOVE_INLINE_IMAGE_LOADER,
} from '../actionTypes/InlineImageLoaderActionTypes';

const showInlineImageLoader = () => ({
    type: SHOW_INLINE_IMAGE_LOADER,
});

const removeInlineImageLoader = () => ({
    type: REMOVE_INLINE_IMAGE_LOADER,
});

export default {
    showInlineImageLoader,
    removeInlineImageLoader,
};
